// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

// jquery
import $ from 'jquery';

// bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'

// swiper
import Swiper from 'swiper/swiper-bundle.min.js';
import 'swiper/swiper-bundle.min.css';
Vue.prototype.Swiper = Swiper

// element
import ElementUI from 'element-ui'
import {
  Loading
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// axios
import axios from 'axios'
Vue.prototype.$axios = axios

// qs
import qs from 'qs';
Vue.prototype.$qs = qs;


import App from './App'
import router from './router'

import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'
Vue.use(vueMiniPlayer)


//白名单
router.beforeEach((to, from, next) => {
  const whiteList = [
    '/','/jobIndex', '/jobDetail', '/messageIndex', '/messageDetail','/activity',
    '/SaleDetail','/BuildImg','/BuildImgType', '/BuildImgDetail','/HouseType','/Dynamics',
    '/HouseTypeDetail','/evaluate','/around','/HOCTIME','/LUARA','/MAESOUL','/BRAND_UPGRADING','/FOLKTALE','/FolktaleDetail','/NewsDetail',
    '/NEW_ARRIVIAL','/Company','/News','/About','/CONSULTANT','/CONTACT','/APP','/TA','/Address','/HoctimeDetail','/AboutHocTime',
    '/COMING_SOON'
  ]
  var userInfoP = sessionStorage.getItem('userInfo');
  if (userInfoP) {
    var token = JSON.parse(userInfoP)
  }
  // console.log(token);
  if (to.path === '/login') {
    if (token) {
      next('/');
    } else {
      next()
    }
  } else {
    if (whiteList.includes(to.path)) {
      next();
    } else {
      if (token) {
        next();
      } else {
        // next();
        next('/login')
      }
    }
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  ElementUI,
  components: {
    App
  },
  template: '<App/>',
  data: function() {
    return {

    }
  },
})



//跳转页面返回顶部
router.afterEach((to, from, next) => {
  window,
  scrollTo(0, 0)
})



// WEBPACK FOOTER //
// ./src/main.js